var _defs, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpanaleonfx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 611.59 614.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 259.34,
    y1: 712.06,
    x2: 266.51,
    y2: -296.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f53428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fc8e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edac4b"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "611.59 0 583.99 55.49 583.68 56.16 528.13 167.82 527.79 168.49 500.19 223.98 219.79 223.98 192.05 168.49 465.85 168.49 466.18 167.82 521.73 56.16 522.07 55.49 27.6 55.49 0 0 611.59 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "484.49 255.54 456.89 311.03 456.55 311.71 337.15 551.72 336.75 552.48 305.78 614.73 274.83 552.48 274.41 551.69 169.02 339.79 230.94 339.79 305.39 489.43 305.78 490.22 306.17 489.43 338.3 424.9 338.69 424.12 338.27 423.3 282.75 311.71 282.42 311.03 154.7 311.03 69.84 140.41 69.5 139.73 41.9 84.25 456.3 84.25 428.55 139.73 131.42 139.73 131.76 140.41 188.71 254.87 189.04 255.54 316.79 255.54 344.36 311.03 344.7 311.71 369.25 361.05 369.64 361.86 370.06 361.07 394.6 311.71 394.94 311.03 422.54 255.54 484.49 255.54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanaleonfx);
export default __webpack_public_path__ + "static/media/Spanaleonfx.bec4954aaee27132ce967d044417dbce.svg";
export { ForwardRef as ReactComponent };